const defaultLayoutConfigObj = {
  // logoAndPlacement: {
  //   useLogo: true,
  //   alignRight: true,
  //   alignLeft: true
  // },
  mspInfo: {
    companylogo: true,
    companyname: true,
    addressLine1: true,
    addressLine2: true,
    addressLine3: true,
    postalCode: true,
    country: true,
    state: true,
    city: true
  },
  clientInfo: {
    clientName: true,
    siteName: true,
    addressLine1: true,
    addressLine2: true,
    addressLine3: true,
    postalCode: true,
    country: true,
    state: true,
    city: true
  },
  tableConfig: {
    discountRate: true,
    tax: true
  },
  styleCustomization: {
    watermark: {
      file: null,
      placement: 'TOP',
      opacity: 10,
      scale: 0
    },
    accent: {
      color: {
        hexCode: '#212529',
        cssVariable: '--sops-invoice-builder-accent-color-black'
      },
      enabled: true
    },
    typography: 'DEFAULT',
    theme: 'CLASSIC'
  }
  // invoiceDetails: {
  //   invoiceId: true,
  //   invoiceDate: true,
  //   invoiceDueDate: true
  // },
  // tableColumn: {
  //   worklogDate: true,
  //   itemDetails: true,
  //   details: true,
  //   quantity: true,
  //   unitPrice: true,
  //   discountRate: true,
  //   tax: true,
  //   amount: true
  // }
};

const defaultAddressFormatConfigObj = {
  sender: {
    content:
      '<p><span class="mention" data-index="0" data-denotation-char="#" data-id="attribute.msp.name" data-value="MSP name">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">#</span>MSP name</span>﻿</span> </p><p><span class="mention" data-index="1" data-denotation-char="#" data-id="attribute.address.line1" data-value="Address line 1">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Address line 1</span>﻿</span> </p><p><span class="mention" data-index="2" data-denotation-char="#" data-id="attribute.address.line2" data-value="Address line 2">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Address line 2</span>﻿</span> </p><p><span class="mention" data-index="3" data-denotation-char="#" data-id="attribute.address.line3" data-value="Address line 3">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Address line 3</span>﻿</span> </p><p><span class="mention" data-index="4" data-denotation-char="#" data-id="attribute.countryCode" data-value="Country">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Country</span>﻿</span> </p><p><span class="mention" data-index="5" data-denotation-char="#" data-id="attribute.stateCode" data-value="State">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">#</span>State</span>﻿</span> </p><p><span class="mention" data-index="6" data-denotation-char="#" data-id="attribute.city" data-value="City">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">#</span>City</span>﻿</span> </p><p><span class="mention" data-index="7" data-denotation-char="#" data-id="attribute.postalCode" data-value="Postal code">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Postal code</span>﻿</span> </p>',
    placeholdersUsed:
      '{"attribute.msp.name":"MSP name","attribute.address.line1":"Address line 1","attribute.address.line2":"Address line 2","attribute.address.line3":"Address line 3","attribute.countryCode":"Country","attribute.stateCode":"State","attribute.city":"City","attribute.postalCode":"Postal code"}',
    mentions: [],
    inlineImages: []
  },
  billing: {
    content:
      '<p><span class="mention" data-index="0" data-denotation-char="#" data-id="entityAttribute.client.name" data-value="Client name">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Client name</span>﻿</span> </p><p><span class="mention" data-index="1" data-denotation-char="#" data-id="entityAttribute.site.name" data-value="Site name">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Site name</span>﻿</span> </p><p><span class="mention" data-index="2" data-denotation-char="#" data-id="attribute.address.line1" data-value="Address line 1">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Address line 1</span>﻿</span> </p><p><span class="mention" data-index="3" data-denotation-char="#" data-id="attribute.address.line2" data-value="Address line 2">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Address line 2</span>﻿</span> </p><p><span class="mention" data-index="4" data-denotation-char="#" data-id="attribute.address.line3" data-value="Address line 3">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Address line 3</span>﻿</span> </p><p><span class="mention" data-index="5" data-denotation-char="#" data-id="attribute.countryCode" data-value="Country">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Country</span>﻿</span> </p><p><span class="mention" data-index="6" data-denotation-char="#" data-id="attribute.stateCode" data-value="State">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">#</span>State</span>﻿</span> </p><p><span class="mention" data-index="7" data-denotation-char="#" data-id="attribute.city" data-value="City">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">#</span>City</span>﻿</span> </p><p><span class="mention" data-index="8" data-denotation-char="#" data-id="attribute.postalCode" data-value="Postal code">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Postal code</span>﻿</span> </p>',
    placeholdersUsed:
      '{"entityAttribute.client.name":"Client name","entityAttribute.site.name":"Site name","attribute.address.line1":"Address line 1","attribute.address.line2":"Address line 2","attribute.address.line3":"Address line 3","attribute.countryCode":"Country","attribute.stateCode":"State","attribute.city":"City","attribute.postalCode":"Postal code"}',
    mentions: [],
    inlineImages: []
  },
  shipping: {
    content: '<p><br /></p>',
    placeholdersUsed: '',
    mentions: [],
    inlineImages: []
  }
};

const defaultInvoiceFieldSettings = [
  {
    fieldName: 'displayId',
    entity: 'Invoice',
    fieldCategory: 'DEFAULT',
    order: 1
  },
  {
    fieldName: 'invoiceDate',
    entity: 'Invoice',
    fieldCategory: 'DEFAULT',
    order: 2
  },
  {
    fieldName: 'dueDate',
    entity: 'Invoice',
    fieldCategory: 'DEFAULT',
    order: 3
  },
  {
    fieldName: 'invoicePaymentTerm',
    entity: 'Invoice',
    fieldCategory: 'DEFAULT',
    order: 4
  }
];

const defaultQuoteFieldSettings = [
  {
    field: 'quoteId',
    entity: 'Quote',
    fieldCategory: 'DEFAULT',
    order: 1
  },
  {
    field: 'quoteDate',
    entity: 'Quote',
    fieldCategory: 'DEFAULT',
    order: 2
  }
];

const LayoutConfigKey = {
  mspInfo: 'invoice.layoutConfigKey.mspInfo',
  companylogo: 'invoice.layoutConfigKey.companylogo',
  companyname: 'invoice.layoutConfigKey.companyname',
  addressLine1: 'invoice.layoutConfigKey.addressLineOne',
  addressLine2: 'invoice.layoutConfigKey.addressLineTwo',
  addressLine3: 'invoice.layoutConfigKey.addressLineThree',
  postalCode: 'invoice.layoutConfigKey.postalCode',
  country: 'invoice.layoutConfigKey.country',
  city: 'invoice.layoutConfigKey.city',
  state: 'invoice.layoutConfigKey.state',
  clientInfo: 'invoice.layoutConfigKey.clientInfo',
  clientName: 'invoice.layoutConfigKey.clientName',
  siteName: 'invoice.layoutConfigKey.siteName',
  tableFormate: 'invoice.layoutConfigKey.table.format',
  groupByNone: 'invoice.layoutConfigKey.groupByNone',
  groupBySite: 'invoice.layoutConfigKey.groupBySite',
  groupByServiceCategory: 'invoice.layoutConfigKey.groupByServiceCategory',
  tableColumn: 'invoice.layoutConfigKey.tableColumn',
  description: 'common.description',
  unitPrice: 'common.unitPrice',
  'hours/quantity': 'metric.quantity.unitsOrHours',
  discount: 'client.contractTemplate.invoiceItems.table.discount',
  tax: 'invoice.layoutConfigKey.tax',
  shippingInfo: 'invoice.layoutConfigKey.shippingInfo'
  // phoneNumber: 'Phone Number',
  // invoiceDetails: 'Invoice Details',
  // tableColumn: 'Table Column',
  // invoiceId: 'Invoice ID',
  // invoiceDate: 'Invoice date',
  // invoiceDueDate: 'true',
  // worklogDate: 'Date',
  // itemDetails: 'Items',
  // details: 'Details',
  // quantity: 'Quality/Hours',
  // unitPrice: 'Unit Prize',
  // discountRate: 'Discount',
  // tax: 'Tax',
  // amount: 'Amount',
  // logoAndPlacement: 'Logo and Placement',
  // useLogo: 'Use logo',
  // alignRight: 'Align Right',
  // alignLeft: 'Align Left'
};

export {
  defaultLayoutConfigObj,
  defaultAddressFormatConfigObj,
  LayoutConfigKey,
  defaultInvoiceFieldSettings,
  defaultQuoteFieldSettings
};
